import { render, staticRenderFns } from "./BacklinkText.vue?vue&type=template&id=24d4e977&scoped=true&"
import script from "./BacklinkText.vue?vue&type=script&lang=js&"
export * from "./BacklinkText.vue?vue&type=script&lang=js&"
import style0 from "./BacklinkText.vue?vue&type=style&index=0&id=24d4e977&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d4e977",
  null
  
)

/* custom blocks */
import block0 from "./BacklinkText.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports